import { createContext } from 'react'

export const SideSheetIndexContext = createContext(0)
